import { useQuery } from '@tanstack/react-query'
import { getMember } from '@/api/organizationApi'
import { useAuthStore } from '@/store/authStore'

/**
 * Hook to get current user's membership info in the selected organization
 * Returns member info including role (owner/admin)
 */
export function useCurrentMember() {
  const user = useAuthStore((state) => state.user)
  const selectedOrganizationId = useAuthStore((state) => state.selectedOrganizationId)

  return useQuery({
    queryKey: ['organization-member', selectedOrganizationId, user?.id],
    queryFn: () => getMember(selectedOrganizationId as string, user?.id as string),
    enabled: !!selectedOrganizationId && !!user?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
